import { ApiClient } from './client.js'
import { PLANS } from './resources.js'

const client = new ApiClient()

export default {
  retrieve (planId) {
    return client.get(`${PLANS}${planId}/`)
  },

  list () {
    return client.get(`${PLANS}`)
  },

  listAll () {
    return client.getAll(`${PLANS}`)
  },

  upgradeOptions () {
    return client.get(`${PLANS}upgrade_options/`)
  },

  upgradeOptionsAll () {
    return client.getAll(`${PLANS}upgrade_options/`)
  }
}
